const authHeader = (isfile) => {
    let user;
    if (process.browser) {
        user = JSON.parse(localStorage.getItem('user'));
    }

    const token = user ? user.token : null;

    if (token) {
        if (isfile) {
            return {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
            };
        } else {
            return {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            };
        }
    }
    if (isfile) {
        return {
            Accept: 'application/json',
        };
    } else {
        return {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        };
    }
};

const setHeader = (method = 'GET', isfile = false) => {
    if (method === 'GET') {
        return {
            method: method,
            headers: authHeader(),
        };
    } else {
        return {
            method: method,
            // credentials: "include",
            headers: authHeader(isfile),
        };
    }
};

const API_HOST = process.env.NEXT_PUBLIC_HOSTNAME;

// Токен хүчингүй/хугацаа дууссан үед (401) хадгалсан session-тэй бол
// автоматаар цэвэрлэж login руу үсэргэнэ. Аноним (login) дуудлагад нөлөөлөхгүй.
// 403 = эрх хүрэхгүй үйлдэл — session хэвээр үлдэж, дуудсан газар алдааг харуулна
// (өмнө нь 403 бүрт хэрэглэгчийг системээс гаргадаг байсан).
const parseResponse = async (response) => {
    if (response.status === 401 && process.browser) {
        const hadSession = localStorage.getItem('user');
        if (hadSession) {
            localStorage.removeItem('user');
            try {
                document.cookie = 'auth_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
            } catch (e) {}
            if (window.location.pathname !== '/admin') {
                window.location.href = '/admin';
            }
        }
    }
    // JSON биш хариу (nginx-ийн 502 HTML гэх мэт) ирэхэд дуудсан код унахгүй
    try {
        return await response.json();
    } catch (e) {
        return { status: 'error', code: response.status, message: 'invalid_response', error: 'invalid_response' };
    }
};

export const get = async (target) => {
    const options = setHeader();

    const response = await fetch(API_HOST + target, options);
    const result = await parseResponse(response);

    return result;
};

export const put = async (target, datas) => {
    const options = setHeader('PUT');
    options.body = JSON.stringify(datas);
    const response = await fetch(API_HOST + target, options);
    const jsonData = await parseResponse(response);
    return jsonData;
};

export const post = async (target, data) => {
    const options = setHeader('POST');

    options.body = JSON.stringify(data);
    const response = await fetch(API_HOST + target, options);
    const result = await parseResponse(response);
    return result;
};

export const destroy = async (target, datas) => {
    const options = setHeader('DELETE');
    options.body = JSON.stringify(datas);
    const response = await fetch(API_HOST + target, options);
    const jsonData = await parseResponse(response);
    return jsonData;
};

export const upload = async (target, data) => {
    const options = setHeader('POST', true);
    options.body = data;
    const response = await fetch(API_HOST + target, options);
    const jsonData = await parseResponse(response);
    return jsonData;
};
